export default () => (obj) => {
    return null;
};
